import { cva } from '@/styled-system/css';

export const avatarBadgeRecipe = cva({
  base: {
    position: 'absolute',
    boxSizing: 'border-box',
    borderRadius: 'shape.ellipse',
  },
  variants: {
    tone: {
      bare: {
        backgroundColor: 'transparent.invisible',
        border: 'none',
        borderRadius: 0,
      },
      hero: {
        backgroundColor: 'bg.accent.brand.hero',
        color: 'icon.onHero.neutral',
        boxShadowColor: 'border.onHero.neutral',
      },
      impact: {
        backgroundColor: 'bg.accent.blue.impact',
        color: 'icon.onHero.neutral',
        boxShadowColor: 'border.onHero.neutral',
      },
    },
    size: {
      xs: {},
      sm: {},
      md: {},
      lg: {
        bottom: 'calc( -1 * {spacing.tighter})',
        right: 'calc( -1 * {spacing.tighter})',
      },
      xl: {
        bottom: 'calc( -1 * {spacing.tighter})',
        right: 'calc( -1 * {spacing.tighter})',
      },
      xxl: {
        bottom: 'calc( -1 * {spacing.tighter})',
        right: 'calc( -1 * {spacing.tighter})',
      },
    },
  },
  compoundVariants: [
    {
      size: 'lg',
      tone: ['hero', 'impact'],
      css: {
        'boxShadow': 'inset 0 0 0 {borderWidths.thick} var(--shadow-color)',
        'padding': 'Avatar.Badge.padding.sm.default',
        '& > [data-c11n-component="Icon"]': {
          width: 'icon.sm',
          height: 'icon.sm',
        },
      },
    },
    {
      size: 'xl',
      tone: ['hero', 'impact'],
      css: {
        'boxShadow': 'inset 0 0 0 {borderWidths.thick} var(--shadow-color)',
        'padding': 'Avatar.Badge.padding.md.default',
        '& > [data-c11n-component="Icon"]': {
          width: 'icon.sm',
          height: 'icon.sm',
        },
      },
    },
    {
      size: 'xxl',
      tone: ['hero', 'impact'],
      css: {
        'boxShadow': 'inset 0 0 0 {borderWidths.thick} var(--shadow-color)',
        'padding': 'Avatar.Badge.padding.lg.default',
        '& > [data-c11n-component="Icon"]': {
          width: 'icon.md',
          height: 'icon.md',
        },
      },
    },
    {
      size: 'lg',
      tone: 'bare',
      css: {
        'padding': 'none',
        '& > [data-c11n-component="Icon"]': {
          width: 'icon.lg',
          height: 'icon.lg',
        },
      },
    },
    {
      size: 'xl',
      tone: 'bare',
      css: {
        'padding': 'Avatar.Badge.padding.md.bare',
        '& > [data-c11n-component="Icon"]': {
          width: 'icon.lg',
          height: 'icon.lg',
        },
      },
    },
    {
      size: 'xxl',
      tone: 'bare',
      css: {
        'padding': 'Avatar.Badge.padding.lg.bare',
        '& > [data-c11n-component="Icon"]': {
          width: 'icon.xl',
          height: 'icon.xl',
        },
      },
    },
    {
      size: ['xs', 'sm', 'md'],
      css: {
        display: 'none',
      },
    },
    {
      size: ['lg', 'xl', 'xxl'],
      css: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
  ],
});
